import { useMe } from "@/api/queries/auth";
import type { ROLE } from "@/types/user";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

export const RoleGuard = ({ roles, children }: { roles: ROLE[]; children: ReactNode }) => {
  const { data: me } = useMe();
  const user = me?.data;

  if (!user || !roles.includes(user.role as ROLE)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
